var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"army army_background"},[_c('scene4',{attrs:{"role":_vm.role,"army-style":"army-style","test-name":"Missie 2"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }